import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import PrecioPlan from './PrecioPlan';
import { useDialog } from './Dialog';

// Se abre con el evento global "upgrade-required" que services/api.js dispara
// cuando el backend responde { upgrade: true } (cuota del plan agotada).
export default function UpgradeModal() {
  const [visible, setVisible] = useState(false);
  const [msg, setMsg]         = useState('');
  const [pro, setPro]         = useState(null);
  const navigate              = useNavigate();
  const panelRef              = useRef(null);
  const cerrar                = useCallback(() => setVisible(false), []);
  useDialog(panelRef, visible, cerrar);

  useEffect(() => {
    const handler = (e) => {
      setMsg(e.detail?.error || 'Has alcanzado el límite de tu plan.');
      setVisible(true);
    };
    window.addEventListener('upgrade-required', handler);
    return () => window.removeEventListener('upgrade-required', handler);
  }, []);

  // Precio vigente para quien mira (fundador o lista), al abrir el modal
  useEffect(() => {
    if (!visible) return;
    api.get('/planes', { skipAuthRedirect: true })
      .then(res => {
        const arr = Array.isArray(res.data) ? res.data : [];
        setPro(arr.find(p => p.nombre === 'pro') || null);
      })
      .catch(() => setPro(null));
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}>
      <div ref={panelRef} tabIndex={-1} role="dialog" aria-modal="true" aria-labelledby="upgrade-titulo" aria-describedby="upgrade-desc"
        className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-sm w-full p-6 animate-scale-in outline-none">
        <div className="text-center mb-4">
          <div aria-hidden="true" className="w-16 h-16 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mx-auto mb-3">
            <span className="text-3xl">⭐</span>
          </div>
          <h2 id="upgrade-titulo" className="text-xl font-bold text-gray-900 dark:text-white">Límite alcanzado</h2>
          <p id="upgrade-desc" className="text-sm text-gray-500 dark:text-gray-400 mt-2">{msg}</p>
        </div>
        <p className="text-center text-sm text-gray-600 dark:text-gray-300 mb-4">
          Con Pro quitas los límites de tu plan y desbloqueas CFDI sin tope, IA financiera y reportes avanzados.
        </p>
        {pro && (
          <div className="flex justify-center mb-5">
            <div className="text-center">
              <PrecioPlan plan={pro} periodo="mensual" compacto />
            </div>
          </div>
        )}
        <div className="flex flex-col gap-2">
          <button type="button" data-autofocus onClick={() => { setVisible(false); navigate('/planes'); }}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 rounded-xl transition">
            Ver planes →
          </button>
          <button type="button" onClick={cerrar}
            className="w-full min-h-[44px] text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 text-sm py-2 transition">
            Continuar con plan gratuito
          </button>
        </div>
      </div>
    </div>
  );
}
